export default "__VITE_ASSET__ff2320b6__"